import '@/logging/useErrorLogging'
import { createApp } from 'vue'
import './index.css'
import '@vuepic/vue-datepicker/dist/main.css'
import 'virtual:uno.css'
import '@/services/infrastructure/firebase.service'
import App from '@/App.vue'
import { getI18nInstance, initializeI18n } from '@/locales/i18n'
import { router } from '@/outerRouter'
import { plugin as transServicePlugin } from '@/transaction/transaction.service'
import { plugin as attachmentPlugin } from '@/services/document.service'
import { plugin as vatPlugin } from '@/vat/vat.service'
import { initializeFirebaseClient } from '@/services/infrastructure/firebase.service'
import { bootstrapService } from '@/services/infrastructure/bootstrap.service'
import '@/hotkeys/useHotkeys'
import { createPinia } from 'pinia'
import './imports'
import { plugin as contaPrime } from '@/prime'
import ui from '@nuxt/ui/vue-plugin'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { versionCheckerVuePlugin } from '@/version-checker'
import { globalErrorHandler } from '@/services/infrastructure/globalErrorHandler'
import { multiPanelPlugin } from '@/multipanel.config'
import '@tritt/multipanel/dist/style.css'

document.title = import.meta.env.VITE_APP_TITLE || 'Conta Pro'

const mountApp = async () => {
    // Initialize Firebase and get services
    const fbServices = await initializeFirebaseClient().catch(console.error)

    // Initialize i18n
    await initializeI18n().catch(console.error)

    // Bootstrap the application (auth + org initialization)
    if (fbServices) {
        await bootstrapService.init(fbServices.application, fbServices.authServices).catch(console.error)
    }

    const app = createApp(App)
        .use(getI18nInstance())
        .use(router)
        .use(createPinia())
        .use(transServicePlugin)
        .use(attachmentPlugin)
        .use(vatPlugin)
        .use(contaPrime)
        .use(versionCheckerVuePlugin)
        .use(ui)
        .use(multiPanelPlugin)

    app.config.errorHandler = globalErrorHandler

    return app.mount('#app')
}

mountApp().then()

window.addEventListener('unhandledrejection', event => {
    globalErrorHandler(event.reason, null, 'unhandledrejection')
})
